export default "__VITE_ASSET__CF3fakki__"